module.exports = __webpack_public_path__ + "static/triangular-process-9e7a3e3a6d1649a15b71b0b23bda1caf.png";